
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Paper, Backdrop
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set, groupBy } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import {getFormState} from '../../../helpers/form';
import dayjs from 'dayjs';
import CircularProgress from '@mui/material/CircularProgress';

const API_HOST = CONFIG.modules['accounts'].host
const API_HOST_CRM = CONFIG.modules['crm'].host







export const Today = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Employees')
    const [data, setData] = useState({})
   
    const [allocating, setAllocating] = useState(false)
    const [allocationByUser, setAllocationByUser] = useState([])

   
    const getAllocatedInfo = () => {
        axios.get(API_HOST_CRM + '/allocate')
        .then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data)
            } 
           
        }).catch((e) => {
      
            console.log(e)
        })
    }

   useEffect(()=> {
    getAllocatedInfo()
   },[])


   useEffect(()=> {
    if(data && data.allocatedCases) {
        const {allocatedCases, allocations} = data
        if (Array.isArray(allocatedCases)) {
            const grouped = groupBy(allocatedCases, 'allocatedToUser')
            setAllocationByUser(allocations.map((a)=>{
                const obj = grouped[a.user._id]
                a.alloted = obj?obj.length:0
                return a
            }))
        }
    }
   },[data])

   


   const allocate = () => {
        setAllocating(true)
        axios.post(API_HOST_CRM + '/allocate')
        .then((resp) => {
            if (resp.data && resp.data.success) {
                getAllocatedInfo()
            } 
            setAllocating(false)
        }).catch((e) => {
            setAllocating(false)
            console.log(e)
        })
   }

    return (
        <>
           {
                allocating &&
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={true}
                    
                    >
                        <Box sx={{display:'flex', flexDirection: 'column', alignItems:'center'}}>
                        <CircularProgress color="inherit" />
                        <Typography variant='p'>{'Allocating ............ Please wait.'} </Typography>
                    
                        </Box>
                        
                    </Backdrop>
            }
            <Box sx={{ mt: 2 }}>
       
            <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: 128,
          height: 128,
        },
      }}
    >
            <Paper elevation={3} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}} >
                <Typography>{`${data.totalAllocated ||0}`}</Typography>
                <Typography>Total Alloted</Typography>
            </Paper>
            <Paper elevation={3}  sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <Typography>{`${(data.capacity ||0)-(data.totalAllocated ||0)}`}</Typography>
                <Typography>Can be Alloted</Typography>
            </Paper>
            <Paper elevation={3}  sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}} >
            <Typography>{`${data.capacity ||0}`}</Typography>
                <Typography>Total Capacity</Typography>
            </Paper>
            <Paper elevation={3}  sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <Typography>{`${data.unallocated || 0}`}</Typography>
                <Typography>Total Unalloted</Typography>
            </Paper>
            </Box>

            <ToolBar name={''} buttons={[
                {
                    name: 'Allocate + ',
                    onClick: () => {
                        allocate()
                    }
                }
            ]} />
                <Grid data={allocationByUser} columns={[
                        { id: 'user', label: 'Name', minWidth: 70, format: (data,row) => {
                            return data?data.name:''
                        } },
                       
                        { id: 'noOfCalls', label: 'Max Allotment', minWidth: 70 },
                        { id: 'alloted', label: 'Alotted', minWidth: 50 },
                        { id: 'forDate', label: 'Call Date', minWidth: 70, format: (data, row)=>{
                            return data?dayjs(data).format('DD-MM-YYYY'):''
                        } },
                   
                ]}
                    // actions={[]}
                    >

                    </Grid>
            </Box>
           
        </>
    )
}